<script>
import CommonMixin from './CommonMixin';
import LauncherOutlet from '@/launcher/components/routes/VR/outlet/LauncherOutlet.vue';

export default {
  name: 'GamesShowRoute',
  mixins: [CommonMixin],
  components: {
    LauncherOutlet,
  },
};
</script>

<template lang="pug">
GamesDetailsBoxConnected.box.h-100
</template>

<style scoped>

</style>
